const types = {
	simple: 'simple',
	custom: 'custom'
};

const locale = {
	ru: types,
	en: types,
	uk: types,
	de: types,
	vi: types,
	th: types
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/popup-types.js